var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.75001C10.5017 6.40995 10.3475 7.06096 10.05 7.65001C9.69722 8.35589 9.15488 8.9496 8.48372 9.36465C7.81257 9.77971 7.03912 9.99971 6.25 10C5.72929 10.0014 5.21413 9.90567 4.73058 9.71906C4.48183 9.62307 4.20772 9.59744 3.95478 9.68176L3.39737 9.86756C2.61561 10.1281 1.87187 9.38441 2.13246 8.60265L2.31826 8.04524C2.40257 7.79229 2.37694 7.51818 2.28095 7.26943C2.09435 6.78588 1.99864 6.27073 2 5.75001C2.00031 4.96089 2.22031 4.18744 2.63536 3.51629C3.05041 2.84514 3.64413 2.3028 4.35 1.95001C4.93906 1.65248 5.59007 1.49829 6.25 1.50001H6.5C7.54217 1.55751 8.52652 1.99739 9.26457 2.73544C10.0026 3.47349 10.4425 4.45784 10.5 5.50001V5.75001Z",
    fill: "#99A2AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.0558a4f556d93c1fbae9310526fff349.svg";
export { ForwardRef as ReactComponent };